import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {LocalCustomerFilterComponent} from '../../../general-components/filter/local-customer-filter/local-customer-filter.component';
import {NumAnnoMeseFilterComponent} from '../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {DeltaChargesModel} from '../../../../models/DeltaChargesModel';
import {ContractTypeFilterComponent} from '../../../general-components/filter/contract-type-filter/contract-type-filter.component';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import { DeltaChargesService } from '../service-delta-charges/delta-charges.service';
import { Observable, Subscription, forkJoin} from 'rxjs';
import { Offset } from 'src/models/Offset';
import * as toastr from 'toastr';
import { DeltaFilterComponent } from 'src/app/general-components/filter/delta-filter/delta-filter.component';
import { ClaimsFilterComponent } from 'src/app/general-components/filter/claims-filter/claims-filter.component';
import * as FileSaver from 'file-saver';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {ContractTypeService} from '../../../general-services/service-contract-type/contract-type.service';
import {MatDialog} from '@angular/material/dialog';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';

@Component({
  selector: 'app-filter-delta-charges',
  templateUrl: './filter-delta-charges.component.html',
  styleUrls: ['./filter-delta-charges.component.scss']
})
export class FilterDeltaChargesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() numAnnoMeseData?: any;
  @Input() filter: DeltaChargesModel;
  @Input() reportSection?: boolean;

  contractTypeData?: any;
  regionData: any;
  localCustomerData: any;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();

  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(NumAnnoMeseFilterComponent) numAnnoFilterComponent;
  @ViewChild(RegionFilterComponent) regionFilterComponent;
  @ViewChild(ContractTypeFilterComponent) contractTypeFilterComponent;
  @ViewChild(DeltaFilterComponent) deltaFilterComponent;
  @ViewChild(ClaimsFilterComponent) claimsFilterComponent;

  filterSingle: AllSettingsFilterModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  deltaSignificativo: any;
  offset: Offset;
  claims: any;
  labelAnnoMeseRif: string;
  fileName: string;
  dataSource: any;
  intermittentBool: boolean;

  constructor(private loaderService: LoaderService,
              private deltaChargesService: DeltaChargesService,
              private numAnnoMeseService: NumAnnoMeseService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private contractTypeService: ContractTypeService,
              private dialog: MatDialog) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new DeltaChargesModel();
    }
    this.filterSingle = AllSettingsFilterModel.getFromDeltaChargesModel(this.filter);
    this.offset = new Offset(10, 0);
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DELTA_CHARGES_FILTER))) {
      this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DELTA_CHARGES_FILTER));
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      allSettingsFilterModel).pipe();

    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable, getAllContractTypeObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });


  }

  interceptRegionChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentFilterButton(true);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.contractTypeData = resultFork[1];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.contractTypeData = resultFork[1];

          this.filter.region = this.filterSingle.region;
          this.filter.contractType = this.filterSingle.contractType;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptContractTypeChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    /** const getAllNumAnnoMeseFilteredObservable: Observable<any> = this.numAnnoMeseService.getAllMonth(
      this.filterSingle.contractType).pipe(); **/
    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();

    // observableList.push(getAllNumAnnoMeseFilteredObservable);
    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          // this.numAnnoMeseData = resultFork[0];
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;

          /** if (!BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
            const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
            this.filter.numAnnoMese = numAnnoMese;
          }**/

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptNumAnnoMeseChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptIsDeltaSignificativoChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptIsClaimsChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.DELTA_CHARGES_FILTER, JSON.stringify(this.filter));
    }
    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const isReset = true;
    this.filter = new DeltaChargesModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filter.isRecovery = 0;
    this.filterSingle = AllSettingsFilterModel.getFromDeltaChargesModel(this.filter);
    this.deltaFilterComponent.reset();
    this.claimsFilterComponent.reset();

    this.numAnnoMeseService.getAllMonth(this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        this.numAnnoMeseData = resultYearMonth;

        const numAnnoMese = resultYearMonth[0] ? resultYearMonth[0] : null;
        this.filter.numAnnoMese = numAnnoMese;

        sessionStorage.setItem(this.SESSION_STORAGE_LABELS.DELTA_CHARGES_FILTER, JSON.stringify(this.filter));
        this.filterSingle = AllSettingsFilterModel.getFromDeltaChargesModel(this.filter);

        this.initFilter(this.filterSingle, isReset);

        this.loaderService.display(false);
      }, error => {
        console.log(error);
        this.loaderService.display(false);
    });
  }

  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.deltaChargesService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.deltaChargesService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  downloadTableXls() {
    this.loaderService.display(true);
    const filter: DeltaChargesModel = new DeltaChargesModel();

    filter.numAnnoMese = this.numAnnoFilterComponent.numAnnoMeseFormControl.value;
    filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    filter.region = this.regionFilterComponent.regionObject;
    filter.localCustomer = this.localCustomerFilterComponent.localCustomerObject;
    filter.contractType = this.contractTypeFilterComponent.contractTypeObject;
    filter.isDeltaSignificativo = this.deltaSignificativo;
    filter.isClaims = this.claims;

    this.getNameSubscribe = this.deltaChargesService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
              const currentDate = new Date();
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(new Blob(
                  [resultPage],
                  { type: this.EXCEL_TYPE }),
                  'delta-charges_' + currentDate + '.xlsx');
              } else {
                FileSaver.saveAs(new Blob(
                  [resultPage],
                  { type: this.EXCEL_TYPE }),
                  'delta-charges_' + currentDate + '.xlsx');
              }
              toastr.success('XLS downloaded with success', 'Success');

              this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }
  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.DELTA_CHARGES}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
    }
    this.filter.localCustomer = this.localCustomerFilterComponent.optionSelected;
    this.filter.region = this.regionFilterComponent.optionSelected;
    this.filter.contractType = this.contractTypeFilterComponent.optionSelected;
    this.filter.isDeltaSignificativo = this.deltaFilterComponent.optionSelected;
    this.filter.isClaims = this.claimsFilterComponent.claims;
    this.loaderService.display(false);
  }

  ngOnDestroy(): void {

  }
}
